/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usernameInput: '',
      passwordInput: '',
      loginHasFailed: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.submitLogin = this.submitLogin.bind(this);
  }

  handleChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }
  submitLogin() {
    const { username, password } = this.props;
    const { usernameInput, passwordInput } = this.state;
    if (username !== usernameInput || password !== passwordInput) {
      this.setState({
        usernameInput: '',
        passwordInput: '',
        loginHasFailed: true,
      });
    } else {
      this.props.handleLogin();
    }
  }

  render() {
    const { usernameInput, passwordInput, loginHasFailed } = this.state;

    return (
      <div className="login-form-wrapper">
        <div className="login-form-header">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Instagram_logo.svg/1280px-Instagram_logo.svg.png"
            alt="Instagram Logo"
          />
        </div>
        <div className="login-form">
          <input
            type="text"
            name="usernameInput"
            id="usernameInput"
            value={usernameInput}
            onChange={this.handleChange}
            placeholder="Phone number, username, or email"
          />
          <input
            type="password"
            name="passwordInput"
            id="passwordInput"
            value={passwordInput}
            onChange={this.handleChange}
            placeholder="Password"
          />
          <button
            disabled={usernameInput === '' || passwordInput === ''}
            type="submit"
            onClick={this.submitLogin}
          >
            Log In
          </button>
        </div>
        <div className="divider">
          <div className="leftline"></div>
          <p>OR</p>
          <div className="rightline"></div>
        </div>
        <div
          style={loginHasFailed ? { display: 'unset' } : { display: 'none' }}
          className="password-hint"
        >
          <p>Wrong userame and/or password</p>
          <p>Try username: dsymiller</p>
          <p>Try password: cohortNY22</p>
        </div>
        <div className="login-form-footer">
          <div className="facebook">
            <a href="#">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="20"
                height="20"
                viewBox="0 0 48 48"
                style={{ fill: '000000' }}
              >
                <path
                  fill="#3F51B5"
                  d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"
                ></path>
                <path
                  fill="#FFF"
                  d="M34.368,25H31v13h-5V25h-3v-4h3v-2.41c0.002-3.508,1.459-5.59,5.592-5.59H35v4h-2.287C31.104,17,31,17.6,31,18.723V21h4L34.368,25z"
                ></path>
              </svg>
              Login with Facebook
            </a>
          </div>
          <div className="forgot-password">
            <a href="#">Forgot password?</a>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;
